const groupedNumberFormatter = new Intl.NumberFormat("en-US");

export const formatNumberWithGrouping = (value: number) =>
  groupedNumberFormatter.format(value);

export const formatNumberForDisplay = (value?: number, fallback = "-") =>
  typeof value !== "number"
    ? fallback
    : Number.isInteger(value)
      ? value.toString()
      : value.toFixed(1);

export const formatDecimal = (value: number, digits = 1) =>
  value.toFixed(digits);

const trimTrailingZeros = (value: string) =>
  value.replace(/\.0+$/, "").replace(/(\.\d*?[1-9])0+$/, "$1");

export const formatStatValue = (
  average?: number | null,
  sd?: number | null,
  digits = 1,
) => {
  if (
    average === null ||
    average === undefined ||
    sd === null ||
    sd === undefined
  ) {
    return null;
  }

  return `${trimTrailingZeros(average.toFixed(digits))} ± ${trimTrailingZeros(sd.toFixed(digits))}`;
};
